export default __webpack_public_path__ + "static/media/high-icon-4.940a0c46.png";